var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransfersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.652 12.976-3.09-3.341a2.804 2.804 0 0 0-1.903-.914.746.746 0 0 0-.159-.016c-.83 0-1.5.726-1.5 1.625v.813c0 .447-.337.812-.75.812h-1.177c-.412 0-.75.366-.75.813 0 .447.338.812.75.812h1.552c1.036 0 1.875-.909 1.875-2.03v-.397c0-.335.253-.61.563-.61.117 0 .22.046.309.112.051.04.103.087.155.137l3.056 3.311c.562.61.562 1.6 0 2.21l-3.056 3.31c-.029.03-.061.056-.094.082a.541.541 0 0 1-.37.152c-.31 0-.563-.274-.563-.61v-.385c0-1.123-.84-2.032-1.875-2.032H11.25c-.412 0-.75.366-.75.813 0 .447.338.812.75.812h6c.413 0 .75.366.75.813v.812c0 .9.67 1.625 1.5 1.625a.716.716 0 0 0 .16-.015 2.785 2.785 0 0 0 1.902-.914l3.09-3.341a3.28 3.28 0 0 0 .848-2.23c0-.807-.277-1.615-.848-2.229z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 4.705c.881 0 1.594.726 1.594 1.625v.823c0 .447.358.812.797.812h2.39c.438 0 .797.366.797.813a.807.807 0 0 1-.797.812H8.867c-1.1 0-1.992-.909-1.992-2.03v-.397a.605.605 0 0 0-.598-.61.594.594 0 0 0-.393.153c-.035.025-.07.05-.1.081l-3.247 3.311c-.598.61-.598 1.6 0 2.21l3.247 3.31c.055.051.11.097.165.137a.57.57 0 0 0 .328.112.605.605 0 0 0 .598-.61v-.395c0-1.123.891-2.032 1.992-2.032h4.836l.1.007c.396.05.697.393.697.806a.807.807 0 0 1-.797.812H9.266a.807.807 0 0 0-.797.813v.812c0 .9-.713 1.625-1.594 1.625a.84.84 0 0 1-.17-.015 3.057 3.057 0 0 1-2.021-.914L1.4 13.435a3.15 3.15 0 0 1-.901-2.23c0-.807.294-1.615.901-2.229l3.283-3.341a3.047 3.047 0 0 1 2.022-.914c.05-.01.1-.016.169-.016zm7.625 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z",
    fill: "#00E1D4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfersActive);
export default __webpack_public_path__ + "static/media/icon-transfers-active.ff8d27efd02e00439a53054a4f0e96b3.svg";
export { ForwardRef as ReactComponent };